import { ParameterDto } from 'src/store/parameters/parameter';
import { ArrayUtils } from 'src/utils/array';
import { ParameterAction, ParameterTypes } from './parameters.actions';

export type ParametersState = Readonly<{
  parameters: ParameterDto[];
  errors: any;
}>;

const initialState: ParametersState = {
  parameters: [],
  errors: null
};

const parametersReducer = (
  state: ParametersState = initialState,
  action: ParameterAction
) => {
  switch (action.type) {
    case ParameterTypes.FetchAll:
      return { ...state, parameters: action.parameters };
    case ParameterTypes.Add:
      return { ...state, parameters: [...state.parameters, action.parameter] };
    case ParameterTypes.Update:
      return {
        ...state,
        parameters: ArrayUtils.updateListById(
          state.parameters,
          action.parameter
        )
      };
    case ParameterTypes.Delete:
      return {
        ...state,
        parameter: null,
        parameters: ArrayUtils.deleteFromListById(
          state.parameters,
          action.parameter
        )
      };
    case ParameterTypes.Failure:
      return { ...state, errors: action.errors };
    default:
      return state;
  }
};

export default parametersReducer;
